<template>
  <div class="payment-wrapper" id="paypal-button-container"></div>
</template>
<script>


export default {
    data: function(){
        return {
          authorizationId: null
        }
    },
    props:{
      total: [String,Number]
    },
    methods:{
      initPaypal(){
          var self = this;
          var result =  paypal.Buttons({
              createOrder: function(data, actions) {
              return actions.order.create({
                  intent: 'AUTHORIZE',
                  purchase_units: [{
                    amount: {
                      value: self.total
                    }
                  }]
              });
              },
              onApprove: function(data, actions) {
                  return actions.order.authorize().then(function(authorization){
                    // Get the authorization id
                    self.authorizationId = authorization.purchase_units[0].payments.authorizations[0].id;
                    self.$emit('success',self.authorizationId);
                  });
              },
              onError: function (err) {
                  self.$emit('success',err);
                  console.log(err);
              },
            }).render('#paypal-button-container');
      }, 
    },
    mounted(){
      
      var intervalId = setInterval(() => {
        if(window.paypal){
          this.initPaypal();
          clearInterval(intervalId)
        }
      }, 150);

    },
    beforeDestroy: function(){
      $('#paypal-button-container').html();
    }
}
</script>

<style scoped>

</style>
